import {createRouter, createWebHistory} from 'vue-router'

//import store from '@/store'

import Dashboard from '../views/dashboard/Dashboard'
import Error404 from "@/views/errors/Error404";
import Login from "@/views/auth/Login";
import Create from "@/views/auth/Create";
import UserProfile from "@/views/users/user/UserProfile";
import User from "@/views/users/User";
import Users from "@/views/users/Users";
import Help from "@/views/Help";
import EventEdit from "@/views/events/EventEdit";
import EventEditAbout from "@/views/events/edit/EventEditIndex";
import EventEditPay from "@/views/events/edit/EventEditPay";
import EventEditMentor from "@/views/events/edit/EventEditMentor";
import EventEditResult from "@/views/events/edit/EventEditResult";
import EventsAdmin from "@/views/events/EventsAdmin";
import EventEditQuestions from "@/views/events/edit/EventEditQuestions";
import UserPassword from "@/views/users/user/UserPassword";
import EventsTimetable from "@/views/events/EventsTimetable";
import EventDetails from "@/views/events/EventDetails";
import UserEvents from "@/views/events/UserEvents";
import UserEvent from "@/views/events/UserEvent";
import UserSchools from "@/views/users/user/UserSсhools";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            layout: 'auth',
        }
    }, {
        path: '/create',
        name: 'UserCreate',
        component: Create,
        meta: {
            layout: 'auth',
        }
    }, {
        path: '/dashboard',
        name: 'Home',
        component: Dashboard
    }, {
        path: '/users',
        name: 'Users',
        component: Users
    }, {
        path: '/users/:user_id',
        props: true,
        component: User,
        children: [
            {
                path: 'profile',
                name: 'UserProfile',
                component: UserProfile,
                props: true,
            },
            {
                path: 'schools',
                name: 'UserSchools',
                component: UserSchools,
                props: true,
            },
            {
                path: 'password',
                name: 'UserPassword',
                component: UserPassword,
                props: true,
            },
            {
                path: 'notify',
                name: 'UserNotify',
                component: UserProfile,
                props: true,
            }
        ],


    },
    {
        path: '/events',
        name: 'EventsTimetable',
        component: EventsTimetable
    },
    {
        path: '/events/:id',
        name: 'EventDetails',
        component: EventDetails,
        props: true,
    },
    {
        path: '/events/e',
        name: 'EventsAdmin',
        component: EventsAdmin
    },
    {
        path: '/events/e/:id',
        props: true,
        component: EventEdit,
        children: [
            {
                path: 'about',
                name: 'EventEditAbout',
                component: EventEditAbout,
                props: true,
            },
            {
                path: 'pay',
                name: 'EventEditPay',
                component: EventEditPay,
                props: true,
            }, {
                path: 'mentor',
                name: 'EventEditMentor',
                component: EventEditMentor,
                props: true,
            }, {
                path: 'questions',
                name: 'EventEditQuestions',
                component: EventEditQuestions,
                props: true,
            }, {
                path: 'result',
                name: 'EventEditResult',
                component: EventEditResult,
                props: true,
            },
        ],

    },
    {
        path: '/user-events',
        name: 'UserEvents',
        component: UserEvents
    },
    {
        path: '/user-events/:id',
        name: 'UserEvent',
        component: UserEvent,
        props: true
    },
    {
        path: '/help',
        name: 'help',
        component: Help
    },


    /*{
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/!* webpackChunkName: "about" *!/ '../views/About.vue')
    }*/
    // will match everything and put it under `$route.params.pathMatch`

    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',

        component: Error404,
        meta: {
            layout: 'default',
        }
    },
]

const router = createRouter({
    routes,
    history: createWebHistory(process.env.BASE_URL)
})
/*router.beforeEach((to, from, next) => {


    /*console.log(to);
    if (to.name !== 'Login' /!*&& !isAuthenticated*!/) next({ name: 'Login' })
    else next()* /

    const publicPages = ['/login', '/create', '/restore'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn =LS.getItem('user');
    //console.log(loggedIn);
    if (authRequired && !loggedIn) {
        return next('/login');
    }


    if ((to.path === '/login' || to.path === '/restore' || to.path === '/create') && loggedIn) {
        return next('/dashboard')
    }
    if (to.path === '/') {
        return next('/dashboard')
    }

    next();
})*/
export default router
